import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isPaid = localStorage.getItem('paymentSuccess') === 'true';
  return isPaid ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
